import { makeStyles } from '@material-ui/core';
import { getContrastTextColor } from '../../../utils/themeHelpers';

const useStyles = makeStyles(
  (theme) => ({
    addonOption: {
      gap: '16px',
      justifyContent: 'space-between',
      alignItems: 'stretch',
      flexWrap: 'nowrap',

      [theme.breakpoints.down('xs')]: {
        flexWrap: 'wrap',
        flexDirection: 'column-reverse',
        gap: '24px',
      },
    },
    imageContainer: {
      width: '212px',
      height: '212px',
      display: 'flex',
      flexShrink: 0,
      overflow: 'hidden',
      borderRadius: '6px',

      [theme.breakpoints.down('xs')]: {
        width: '100%',
        flexWrap: 'wrap',
        alignItems: 'center',
      },
    },
    image: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    },
    content: {
      justifyContent: 'space-between',
      width: '100%',

      [theme.breakpoints.down('xs')]: {
        alignItems: 'center',
      },
    },
    contentText: {
      maxWidth: '350px',

      [theme.breakpoints.down('xs')]: {
        maxWidth: '100%',
      },
    },
    header: {
      gap: '12px',
      justifyContent: 'space-between',
    },
    description: {
      color: theme.colors.secondaryTextColour ?? theme.colors.smoke,
      fontSize: '16px',
      lineHeight: '26px',
    },
    learnMore: {
      // TODO better hover state
      textDecoration: 'underline',
      color: theme.colors.charcoal,
      '&:hover': {
        filter: 'brightness(95%)',
      },
    },
    footer: {
      color: theme.colors.darkGrey,
      fontWeight: theme.fontWeights.medium,
      textAlign: 'right',
      fontSize: '14px',
      justifyContent: 'flex-end',
    },
    price: {
      fontFamily: theme.baseTypography.numberFontFamily,
      fontSize: '18px',
    },
    container: {
      position: 'relative',
      cursor: 'pointer',
      color: theme.colors?.mainTextColour,
      border: `1px solid ${theme.colors.outlineColour}`,
      borderRadius: '12px',
      height: '38px',
      width: '140px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&:hover': {
        border: `1px solid ${theme.colors.charcoal}`,
        backgroundColor: theme.colors.activeFieldsBackground,
        filter: 'brightness(95%)',
        transition: 'filter 0.1s',
        color: getContrastTextColor(theme.colors.activeFieldsBackground),
      },
    },
    selected: {
      backgroundColor: theme.colors.activeFieldsBackground,
      border: `1px solid ${theme.colors.charcoal}`,
      color: getContrastTextColor(theme.colors.activeFieldsBackground),
    },
  }),
  { name: 'AddonOption' },
);

export default useStyles;
